import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'DAY1 \n Trending Innovations',
                topics: [
                    `Server-Driven UI`,
                    `Sustainability`,
                    `Scalability`,
                    `Growing Role of Python`,
                    `Low-Code/No-Code Development`,
                    `Microservices Innovations`,
                    `Progressive Web Applications (PWAs)`,
                    `Blockchain Integration`,
                    `Cloud Native Architecture`,
                    `DevSecOps`,
                    `Cloud Computing`,
                    `Infrastructure as Code (IaC) and other potential topics`,
                ],
            },
            {
                title: 'DAY2 \n AI in Architecture',
                topics: [
                    `Augmented Reality`,
                    `Virtual Reality`,
                    `AI Integration Operations`,
                    `AI-as-a Service Overview`,
                    `Large Language Models connectivity`,
                    `Data-Driven Architecture`,
                    `Copilot Era Challenges`,
                    `AI and Ethical approaches and many more`,
                ],
            },
            {
                id: 3,
                title: 'Bonus Feature:\n G.Digest *New*',
                topics: [
                    'Get Reesl-style trailers for each conference session in a recap.',
                    'View, select, and learn from your favorite sessions, easily skipping the rest and saving time efficiently.',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className={`getReady_item ${item.id === 3 ? 'hover' : ''}`} key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <h3 className='getReady_item--title'>{item.title}</h3>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li p2' key={`getReady_li-${i + item}`}><span>[]</span> {item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_wrap'>
            <div className='container getReady'>
                <h2 className='getReady_title colorful'>What event is about</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about;